import React from 'react';
import Styles from './Button.css';
import clsx from 'clsx';

/**
 * @param {import('../../../../../types/SimuladorEnergiaSolar').ButtonProps} props
 */
function Button({ children, variant = 'red', maxWidth, centered, loading, ...props }) {
  return (
    <>
      <button
        {...props}
        type={props.type || 'button'}
        className={clsx(
          variant !== 'flat' && 'sn-button',
          variant === 'flat' && 'sn-button-flat',
          variant,
          centered && 'centered',
          loading && 'loading',
          props.className,
        )}
        style={maxWidth ? { ...props.style, maxWidth } : props.style}
      >
        {children}
      </button>
      <style jsx>{Styles}</style>
    </>
  );
}

export default Button;
